import { unstable_createMuiStrictModeTheme as createTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { useAppSelector } from '../../app/hooks';
import { BaseProps } from '../../common/BaseProps';
import { selectLoading, selectLoadingCount, selectMessage } from '../../globalSlice';
import Footer from '../Footer/Footer';
import LoadingGlobal from '../LoadingGlobal/LoadingGlobal';
import Message from '../Message/Message';
import NavBar from '../NavBar/NavBar';
import styles from './MainContainer.module.css';
import logoGovbr from '../../assets/img/logo-govbr.svg';
interface Props extends BaseProps {
  userNav?: boolean;
  titleBarraAuxiliar?: string;
  titleBarraAuxiliarHelp?: () => void;
  barraAuxiliarLogout?: boolean;
  barraAuxiliar?: boolean;
  padraoInicial?: boolean;
  navOverAll?: boolean;
  navTitle?: string;
  stoppedTitle?: boolean;
  navGoBack?: () => any;
  navHideArrow?: boolean;
  navFixed?: boolean;
  navSeparator?: boolean;
  showFooter?: boolean;
  navLogout?: () => any;
  navCaixaMensagens?: () => any;
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#1351b4',
    },
  },
  typography: {
    fontFamily: [
      'rawline'
    ].join(','),
  },
});

const MainContainer: React.FC<Props> = (props) => {
  const {
    userNav,
    navTitle,
    stoppedTitle,
    barraAuxiliarLogout,
    titleBarraAuxiliar,
    titleBarraAuxiliarHelp,
    barraAuxiliar,
    padraoInicial,
    navGoBack,
    navHideArrow,
    navFixed = false,
    navSeparator,
    showFooter = true,
    navLogout,
    navCaixaMensagens,
  } = props;

  const isLoading = useAppSelector(selectLoading);
  const loadingCount = useAppSelector(selectLoadingCount);
  const message = useAppSelector(selectMessage);

  return (
    <ThemeProvider theme={theme}>
      <div className={styles.govBrHeader}>
        <a className={styles.logo} href="https://www.gov.br/">
          <img src={logoGovbr} alt="Logo gov.br" />
        </a>
      </div>
      <NavBar
        barraAuxiliarLogout={barraAuxiliarLogout}
        title={navTitle}
        stoppedTitle={stoppedTitle}
        titleBarraAuxiliar={titleBarraAuxiliar}
        titleBarraAuxiliarHelp={titleBarraAuxiliarHelp}
        barraAuxiliar={barraAuxiliar}
        padraoInicial={padraoInicial}
        hideArrow={navHideArrow}
        goBack={navGoBack}
        fixed={navFixed}
        separator={navSeparator}
        logout={navLogout}
        caixaMensagens={navCaixaMensagens}
        userNav={userNav}
      />
      <div className={`${styles.content} ${navFixed ? styles.navFixed : ''}`}>
        {message && (
          <Message
            type={message.type}
            title={message.title}
            text={message.text}
            className={styles.globalMessage}
          />
        )}
        {props.children}
      </div>
      {showFooter && <Footer />}
      {(isLoading || loadingCount > 0) && <LoadingGlobal />}
    </ThemeProvider>
  );
};

export default MainContainer;
